import React, { FC, useMemo } from "react";
import dynamic from "next/dynamic";

const SuzuHead = dynamic(
  () => import("components/front/custom/sydm2/SuzuHead")
);

// テンプレートリテラルでの動的インポートはnext10で対応できる。それまでは固定switchで対処。
// @see https://github.com/vercel/next.js/issues/4100
const SpBottomLeftCorner: FC<{ projectCode: string }> = ({ projectCode }) => {
  return useMemo(() => {
    switch (projectCode) {
      case "sydm2":
        return <SuzuHead />;
      default:
        return <></>;
    }
  }, [projectCode]);
};

export default SpBottomLeftCorner;
